<template>
	<div>
		<myheader :headTitle="headertitle"></myheader>
		<div class="all_main backgroundC_white">
			<div class="all_content_padding">
				<!-- <div class="text14 textcolor333 margin_top_5" style="white-space: pre-wrap;padding: .5rem;">
					{{content}}
				</div> -->
				<div class="agreement">
					<div class="content" v-if="type === 1||type === '1'">
						<h4>中石化电子签约平台用户服务协议</h4>
						<div>发布日期： 2021 年 11 月 26 日</div>
						<div>生效日期： 2021 年 11 月 26 日</div>
						<div>本网站由石化盈科信息技术有限责任公司（下称“我们”或“本公司”）负责运营。<span
								style="display:inline">我们为中国石油化工集团有限公司的子公司，负责运营中石化电子签约平台。</span></div>

						<p>本协议双方为本公司与注册用户（下称“用户”或“您”），本协议具有合同效力，适用于您在【中石化电子签约平台，网址：<a>https://esign.sinopec.com</a>】网站（下称“本平台”）的全部活动。
						</p>
						<h5>一、声明与承诺</h5>
						<p>(一)在使用本服务前，您已充分阅读、理解并接受本协议的全部内容，一旦您使用本服务，即表示您同意遵循本协议之所有约定。若您不同意本协议的任意内容，或者无法准确理解本协议内容，请不要进行后续操作。
						</p>
						<p>(二)本协议内容包括以下条款及已经发布的或将来可能发布的各类规则。所有规则为本协议不可分割的一部分，与协议正文具有同等法律效力。本平台有权根据需要不定时地制定、修改本协议或各类规则，如本协议及规则有任何变更，一切变更以本网站最新公布的内容为准。
						</p>
						<p>(三)在您同意接受本协议所声明内容时，您已经年满18周岁。不具备前述条件的，您应立即终止注册或停止使用本服务。</p>
						<p>(四)您认可使用电子签约作为缔约（包括但不限于电子合同）方式，认可您在电子签约平台上的所有操作都是您个人意愿的表示，认可您在电子签约平台上签订的电子合同（或协议）和纸质合同（或协议）具备相同的效力，认可您在电子签约平台上的电子签名和您的手写签名具备相同的效力。
						</p>
						<p>(五)电子签约服务需要用户进行实名认证，认证手段包括<span
								style="display:inline">手机短信验证、人脸识别、银行账户信息验证</span>等，我公司会根据用户场景调整用户实名认证技术手段。<span
								style="display:inline">如您不同意向我们提供实名认证所需的相关信息，我们将无法向您提供电子签约服务，您可以选择采用纸件方式进行合同签约。</span>
						</p>
						<p>(六)本公司有权在必要时要求核对您的有效身份证件或其他必要文件，并留存您提交的有效身份证件信息、通过拍照、录像等方式产生的电子文件信息，您应积极配合，否则本公司有权限制或停止向您提供部分或全部电子签约服务。
						</p>
						<p>(七)本公司有权按照包括但不限于公安机关、检察机关、法院、海关、税务机关等司法机关、行政机关、军事机关的要求对您的个人信息及在电子签约的电子信息等进行查询、冻结或其他操作。</p>
						<p>(八)按照本公司要求准确提供您正确、最新及完整的身份信息及相关资料，包括但不限于联系电话、联系地址等。若本公司有合理理由怀疑您提供的身份信息及相关资料错误、不实、过时或不完整的，本公司有权暂停或终止向您提供部分或全部电子签约服务。本公司对此不承担任何责任，您将承担因此产生的任何直接或间接支出。若因国家法律法规、部门规章或监管机构的要求，本公司需要您补充提供任何相关资料时，如您不能及时配合提供，本公司有权暂停或终止向您提供部分或全部电子签约服务。
						</p>
						<p>(九)用户同意通过本平台向北京国富安电子商务安全认证公司（下称“CA机构”）申请并使用CA机构颁发给用户的数字证书，承诺在申请证书时提供真实、完整和准确的信息及证明材料。如因故意或过失未提供真实、完整和准确的信息，导致CA机构签发证书错误，造成相关各方损失的，由用户承担相关责任。
						</p>
						<p>(十)您使用中石化电子签约平台即表示您同意中石化电子签约平台将您的个人身份信息或企业信息、其个人或企业的电子签名认证信息传输至公司合作的CA机构，且前述信息保存至数字证书失效后5年，且该等信息不因您的账户锁定或禁用而停止保存。
						</p>
						<p>(十一)请注意：根据《电子签名法》的规定下列情形不适合使用电子文书：涉及婚姻、收养、继承等人身关系的；涉及停止供水、供热、供气等公用事业服务的；法律、行政法规规定的不适用电子文书的其他情形。因此，用户不得在中石化电子签约平台上签订上述法律文件。若用户在中石化电子签约平台上传并签订上述法律文件，而根据法律之规定上述签约行为无效的，中石化电子签约平台不承担任何责任。
						</p>
						<h5>二、定义及解释</h5>
						<p>(一)中石化电子签约平台账户：是本平台向您提供的唯一编号。您可自行为该账户设置密码，并用以查询或发起代表您个人或者组织的签约过程。您需使用本人平台账户或手机号码，或者本公司允许的其它方式，作为登录手段登录中石化电子签约平台账户。
						</p>
						<p>(二)区块链企业：指提供区块链技术的第三方合作企业。</p>
						<p>(三)CA机构：指获得《电子认证服务许可证》的第三方数字证书签发机构。</p>
						<p>(四)电子签名认证证书：即数字证书，指由CA机构签发的，含有签发电子签名认证证书的电子认证服务机构名称、证书持有人名称、证书序列号、证书有效期、证书持有人的电子签名验证数据、电子认证服务机构的电子签名、工业和信息化部规定的其他内容的身份证明数据。
						</p>
						<p>(五)电子签名：指数据电文中以电子形式所含、所附用于识别签名人身份并表明签名人认可其中内容的数据。</p>
						<p>(六)数据电文：指以电子、光学、磁或者类似手段生成、发送、接收或者储存的信息。</p>
						<p>(七)身份信息：指您的姓名、联系方式以及您有效身份证件的种类、号码和有效期限等能够依法识别您身份的个人信息；或者您作为企业授权代表提交的企业信息，包括但不限于营业执照、组织机构代码证、企业法定代表人姓名及其身份证信息等。
						</p>
						<h5>三、中石化电子签约平台服务</h5>
						<p>（一）电子合同签约服务</p>
						<p>采用电子签名、时间戳等技术，实现对数据电文的安全保护和签章信息的图形化展现，明确电子文件签署者各方的身份信息、签署行为的过程以及签署完成后文件改动，从而使用户在线完成文件的签署。</p>
						<p>（二）电子合同数据存证及下载服务</p>
						<p>用户签署的文件在完成后，将由中石化电子签约平台对签署完成的文件本身以及签署全流程信息等内容进行保存用户签署文件全流程信息的日志将同步至中石化电子签约平台合作的第三方区块链企业。合同的相对人可在文件签署后的【五】年内在本平台随时下载签署完成的合同。
						</p>
						<p>（三）中石化电子签约平台出证服务</p>
						<p>中石化电子签约平台与第三方区块链企业及CA机构就电子签名服务相关内容达成战略协议。第三方区块链企业及CA机构均可出具报告文件，该文件包含了合同签署全流程信息，以供本地存档查阅，并可作为调解、仲裁等争议解决过程中的合同相关证据出示。
						</p>
						<h5>四、用户账户</h5>
						<p>（一）中石化电子签约平台用户</p>
						<p>中石化电子签约平台的用户目前仅支持企业用户，包括管理员用户和普通用户。使用中石化电子签约平台提供服务的企业必须是依据中华人民共和国法律在境内（香港、台湾、澳门除外）设立的，能够独立承担民事责任的法人和其他组织。管理员用户是指中华人民共和国公民，并获得企业线下开具授权书在本平台进行开通企业用户使用申请的用户。普通用户是指中华人民共和国公民，且由管理员用户审批通过的用户。使用中石化电子签约平台提供服务的管理员用户及普通用户都必须是符合中华人民共和国法律规定的年满18周岁的自然人，且已在本平台完成注册的用户。
						</p>
						<p>（二）账号开通与实名认证</p>
						<p>1.注册用户在本平台完成企业账号开通程序方可成为中石化电子签约平台的管理员用户，注册用户经管理员的审批通过方可成为中石化电子签约平台的普通用户。注册用户应登录中石化电子签约平台进行实名认证。在账号开通与实名认证过程中个人及企业必须根据本平台的要求提供最新、真实、有效及完整的资料。其中，根据实名认证方式的不同，个人所需提供的实名认证资料将有所差异，具体所需资料请以本平台要求为准。企业需要提供的实名认证资料包括但不限于营业执照、组织机构代码证、企业法定代表人姓名及其身份证信息，并且企业认证需要选择：1）法定代表人扫脸认证+企业银行基本账户打款认证，或者2）企业出具的盖章授权书+企业银行基本账户打款认证，以上任意一种方式进行实名认证。
						</p>
						<p>2.实名认证具体操作流程请严格按照本平台实名认证规定的流程履行，否则将影响实名审核的结果。</p>
						<p>3.用户同意并授权中石化电子签约平台审核、核对用户资料信息以确认用户身份，但用户信息是由用户本人自行提供的，故中石化电子签约平台无法保证该信息之准确、真实性、有效性和完整。所提交的用户认证信息将用于用户账号的实名认证以及核发其专属的电子签名文件，中石化电子签约平台将对用户的信息进行严格保密。用户的个人信息及隐私保护请详见《<a
								@click="openPrivacyment(2)">隐私政策</a>》。 </p>
						<p>（三）账户安全</p>
						<p>1.中石化电子签约平台将通过用户的账号、密码以及登录后的其他操作识别用户的相关指示，同时中石化电子签约平台会通过本服务应用识别来自用户通过各类产品或设备登录、使用本平台的指示，用户应当妥善保管中石化电子签约平台账号、密码、身份信息，以及关联用户账号的各类产品或设备，对于因用户泄露账号、密码、身份信息或是因产品或设备遗失导致的损失，由用户自行承担。用户应在登录本系统时段结束时，以通过点击退出按钮的正确步骤离开平台。如果用户在登录3个小时及以上未进行任何操作，平台将自动退出登录。用户如果发现有他人冒用或盗用其中石化电子签约平台账号及密码或任何其他未经合法授权之情形，或发生与中石化电子签约平台账户关联的手机或其他设备遗失或其他可能危及到中石化电子签约平台账户安全情形时，应立即以有效方式通知本公司，向本公司申请账户锁定。
						</p>
						<p>2.用户应对其持有的中石化电子签约平台账户负责，只有用户本人方可使用该账户。该账户不可转让、不可继承，在您决定不再使用该账户时，您应将该账户内的数据导出或删除，并按本公司规定流程向本公司申请注销该账户。
						</p>
						<p>3.中石化电子签约平台可以暂时停止提供或者限制本服务部分功能，或提供新的功能。<span
								style="display:inline">在本平台任何功能或本协议、平台规则发生变化时，本平台将会通过邮件通知、公告等方式告知您，请您及时阅读相关信息。若您不同意上述有关变更，其有权以通知本平台终止本协议。如用户未在告知后的合理期间内提出异议，且仍然使用本服务，即表示同意本协议或者变更后的协议。</span>
						</p>
						<p>4.中石化电子签约平台对因用户未能遵守本协议的约定而发生的任何直接或间接损失等不利后果不承担任何责任。</p>
						<p>5.中石化电子签约平台有权了解您使用本公司产品或服务的真实交易背景及目的，用户应如实提供本公司所需的真实、全面、准确的信息。如果本公司有合理理由怀疑用户提供虚假信息、进行欺诈等违法违规行为的，本公司有权根据相关国家法律法规的规定对用户个人信息以及签署的文件信息等进行核实、查询、披露，有权锁定相应账户并配合相关机关进行后续调查。
						</p>
						<p>（四）账户锁定</p>
						<p>用户登录中石化电子签约平台账户，若密码连续5次输入错误，中石化电子签约平台将锁定该账户，需要重新找回密码。账户被锁定期间，用户将无法使用中石化电子签约平台的任何服务。</p>
						<p>（五）账户注销</p>
						<p>1.在您需要终止使用我们的服务时，您可以申请注销您的账户，您可以联系我们的人工客服，申请注销您的账户。
							我们在此善意地提醒您，您注销账户的行为会使您无法继续使用中石化电子签约平台的相关服务，包括合同下载以及出证服务。注销账户后您的个人信息会保持不可被检索、访问的状态，我们将不会再使用或对外提供与该账户相关的个人信息，但您在使用中石化电子签约平台服务期间提供或产生的信息我们仍需按照监管要求的保存5年以上，且在保存的时间内依法配合有权机关的查询。
						</p>
						<h5>五、通知与送达</h5>
						<p>（一）通知方式</p>
						<p>本协议条款及任何其他的协议、公告或其他关于您使用本服务账号及服务的通知，您同意本平台使用电子方式通知您。电子方式包括但不限于以电子邮件方式、或于本平台或者合作平台上公布、或无线通讯装置通知等方式。请您密切关注本平台发布的公告、通知和提示，及时阅读并理解。
						</p>
						<p>（二）送达</p>
						<p>平台的功能升级及服务变更通知将以公示方式做出并设置已阅功能，用户在登录时需完成阅读才能成功登录平台。如果相关非专属性的通知可能影响用户重大权益的除此之外，其他向您个人发布的具有专属性的通知将由本平台在您申请开通时或者开通后变更用户信息时向本平台提供的电子邮箱或用户开通后在本平台绑定的手机号码发送，在发送成功后即视为已经送达。请您密切关注用户的电子邮箱以及手机中的短信信息。因信息传输或您变更邮箱但未在本平台的注册信息中填写您变更后的邮箱等原因导致您未在前述通知发出当日收到该等通知的，本平台不承担责任。
						</p>
						<p>（三）通知内容</p>
						<p>您同意中石化电子签约平台利用在本平台登记的联系方式与您联络并向您传递相关的信息，包括但不限于行政管理方面的通知、产品信息、本协议及平台规则的变更、有关您使用本平台的通讯等。</p>
						<h5>六、使用事项</h5>
						<p style="font-weight:900">
							（一）您在使用中石化电子签约平台服务时，必须遵守国家各项法律、法规、规章以及政府规范性文件，并接受中石化电子签约平台相关的协议、规则、规定、程序和惯例的约束。禁止在本平台进行任何可能违反国家法律、法规、规章和政府规范性文件的行为（包括但不限于侵犯任何第三方著作权、专利权、商标权、商业秘密、隐私权、名誉权或其它权利的行为）或者任何未经授权使用本平台的行为（包括但不限于擅自进入本平台未公开的系统、不正当的使用密码和平台的任何内容等）。
						</p>
						<p style="font-weight:900">
							（二）本平台仅支持企业用户，您作为企业授权代表须妥善保管您在中石化电子签约平台上的账号和密码。本平台通过您的账号、密码以及登录后的操作来识别您的指令。您确认，使用您的账号和密码登录本平台后在本平台的一切行为均代表您所代表的企业意志。使用您的账号和密码登录操作所产生的电子信息记录均为您所代表的企业行为的有效凭据，并由您所代表的企业承担相应的法律后果。用户不得在未经中石化电子签约平台许可的情况下出售或授权任何第三方使用您所持有的账号。
						</p>
						<p>（三）您及其所代表的企业对通过中石化电子签约平台发布的所有信息（内容包括但不限于个人信息、商业信息，形式包括但不限于文字、图片）的真实性、准确性、即时性、完整性和合法性独立承担所有责任。同时，在您所发布的信息中不得含有蓄意毁坏、恶意干扰、秘密地截取或侵占任何系统、数据或个人资料的任何病毒、伪装破坏程序、电脑蠕虫、定时程序炸弹或其他电脑程序。
						</p>
						<p>（四）本平台内容可能涉及由第三方所有、控制或运营的其它平台（以下称“第三方平台”）。本平台不能保证也没有义务保证第三方平台上的信息的真实性和有效性。您应按照第三方平台的相关协议与规则使用第三方平台，而不是按照本协议。第三方平台的内容、产品、广告和其他任何信息均由您自行判断并承担风险，而与本平台无关。
						</p>
						<h5>七、用户间纠纷处理</h5>
						<p>(一)用户应在使用中石化电子签约平台服务时，应审慎核查签署各方的身份信息，对于签署方中有未经中石化电子签约平台实名认证的用户，可能产生签约主体不明或签约主体错误的风险，如需避免此风险，请各签署方进行实名认证并审慎核查签署方身份。否则，因此而产生的风险和责任，由用户自行承担。
						</p>
						<p>(二)在使用中石化电子签约平台的过程中，用户发现任何可能侵害自己或中石化电子签约平台权利的事实时，应及时通知中石化电子签约平台并提供相应的证明材料。因投诉不实给中石化电子签约平台或第三方造成损失的，用户应承担法律责任。
						</p>
						<p>(三)中石化电子签约平台有权接受并处理您与其他用户间因使用中石化电子签约平台服务而产生的纠纷及投诉，有权通过电话、短信、电子邮件等联系方式向您了解情况，并将所了解的情况通过上述方式通知对方。您有义务在收到中石化电子签约平台通知后，在指定的时间内提供相应的资料，以配合纠纷及投诉的情况了解与处理，否则，中石化电子签约平台有权单方面独立判断其他用户对您的投诉。一旦投诉成立，可能做出对您不利的处理结果。同时，中石化电子签约平台有权立即中止或终止您的相关中石化电子签约平台服务。
						</p>
						<p>(四)中石化电子签约平台受理、处理纠纷、争议及投诉完全依据您的授权。因中石化电子签约平台对证据的鉴别能力及对纠纷的处理能力有限，不保证处理结果一定符合您的期望。<span
								style="display:inline">中石化电子签约平台有权决定是否参与争议的处理。</span></p>
						<p>(五)经生效法律文书确认用户存在违法或违反本协议行为，或者中石化电子签约平台自行判断您涉嫌存在违法或违反本协议行为的，中石化电子签约平台有权公布用户的违法行为并做出相应处理，包括但不限于终止服务、永久禁止使用中石化电子签约平台等。
						</p>
						<h5>八、知识产权声明 </h5>
						<p>无论是否明示，中石化电子签约平台对平台内所有非公有领域或非他方专有的信息内容享有知识产权（包括但不限于商标权、专利权、著作权），信息内容包括但不限于文字、图片、软件、音频、视频、数据、源代码、设计。非经中石化电子签约平台书面授权同意，任何组织或个人都不得复制、打印和传播属于中石化电子签约平台的信息内容用于其他用途。平台所有的产品、技术及程序均属于中石化电子签约平台知识产权，未经中石化电子签约平台书面授权许可，任何人不得擅自使用（包括但不限于以非法的方式打印、复制、传播、展示、下载等）。否则，中石化电子签约平台将依法追究其法律责任。
						</p>
						<h5>九、免责声明</h5>
						<p style="font-weight:900">
							(一)您有义务在申请开通时提供自己的真实、最新、完整的资料，并保证电子邮件地址、联系电话、联系地址、邮政编码等内容的最新、有效性及安全性。您有义务维护并立即更新您的个人资料，确保其真实、最新、有效及完整。若您提供任何错误、虚假、过时或不完整的资料，或者本平台有合理的理由怀疑您提供的为错误、虚假、过时或不完整的资料时，本平台有权锁定您的账号，并拒绝您使用本平台部份或全部服务。在此情况下，本平台不承担任何责任，并且您同意自行承担因此所产生的直接或间接的任何支出或损失。
						</p>
						<p>(二)在如下情况，中石化电子签约平台有权中止、终止对您提供部分或全部服务而不承担任何责任：</p>
						<p>1.在中石化电子签约平台未向您收费的情况下，中石化电子签约平台可自行全权决定以合理理由 (包括但不限于您已违反本协议的字面意义和精神，或您以不符合本协议的字面意义和精神的方式行事)
							终止您的登录账号、密码(或其任何部分) 或您对服务的使用。</p>
						<p>2.在出现下列任一情况时，中石化电子签约平台可立即发出警告，中止或终止您的账号，删除您的任何现有信息，以及您在平台上展示的任何其他资料：（a）您违反本协议；(b)中石化电子签约平台无法核实或鉴定您向中石化电子签约平台提供的任何资料；（c）中石化电子签约平台相信您的行为可能会使您、中石化电子签约平台其他用户或通过中石化电子签约平台提供服务的第三者服务供应商发生任何法律责任；(d)发现您从事涉及平台的诈骗等违法违规活动，中石化电子签约平台有权中止或终止您的服务。对于（a）、（b）、(c)三项，中石化电子签约平台不限制用户采取相关补救措施。
						</p>
						<p>3.对于本协议规定的采取的中止或终止措施，中石化电子签约平台不对结果承担任何责任。</p>
						<p>4.根据本协议的任何规定中止或终止您使用服务之措施，中石化电子签约平台将本着审慎的态度实施，并将履行告知义务，即使通知您不能继续使用中石化电子签约平台的服务，但在您的账号内的所有相关资料，中石化电子签约平台将继续为您保存，且可以查询和为您提供相关文件内容的证明。
						</p>
						<p style="font-weight:900">
							5.由于互联网本身所具有的不稳定性，中石化电子签约平台无法保证服务不会中断。系统因有关状况无法正常运作，使用户无法使用任何中石化电子签约平台服务或使用中石化电子签约平台服务受到任何影响时，中石化电子签约平台对用户或第三方不负任何责任，前述状况包括但不限于：
						</p>
						<p style="font-weight:900">（1）中石化电子签约平台系统停机维护期间。</p>
						<p style="font-weight:900">（2）电信设备出现故障不能进行数据传输的。</p>
						<p style="font-weight:900">（3）由于黑客攻击、网络供应商技术调整或故障、平台升级、银行方面的问题等原因而造成的中石化电子签约平台服务中断或延迟。</p>
						<p style="font-weight:900">（4）因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素，造成中石化电子签约平台系统障碍不能执行业务的。</p>
						<p style="font-weight:900">
							6.因非中石化的过错导致的任何损失，该过错包括但不限于：用户操作不当、遗忘或泄露密码、用户密码被他人破解、用户使用的计算机系统被第三方侵入、用户委托他人代理签署时他人恶意或不当操作而造成的损失，中石化电子签约平台不承担任何责任。
						</p>
						<h5>十、违约责任</h5>
						<p>(一)因您违反本协议或经在此提及而纳入本协议的其他文件，或因您违反了法律、法规、规章、政府规范性文件或侵害了第三方的权利，而使第三方对中石化电子签约平台及其股东、职员、代理人提出索赔要求（包括司法费用和其他专业人士的费用），您必须对中石化电子签约平台及股东、职员、代理人承担赔偿责任，使其等免遭损失。
						</p>
						<p>(二)如因中石化电子签约平台违反有关法律、法规或本协议项下的任何条款而给用户造成损失，中石化电子签约平台同意承担由此造成的损害赔偿责任。</p>
						<p>十一、法律适用与管辖</p>
						<p>本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律，没有相关法律规定的，参照通用国际商业惯例和（或）行业惯例。因本协议产生之争议，均应依照中华人民共和国法律予以处理，并由北京市朝阳区人民法院管辖。
						</p>
						<!-- <p>用户服务协议历史版本参考：</p>
				      <p>中石化电子签约平台用户服务协议（发布日期：2020年01月10日）</p>
				      <p>中石化电子签约平台用户服务协议（发布日期：2019年08月05日）</p> -->
					</div>
					<div class="content" v-if="type === 4||type === '4'">
						<h4>中石化电子签约平台数字证书使用协议</h4>
						<div>发布日期： 2021 年 11 月 26 日</div>
						<div>生效日期： 2021 年 11 月 26 日</div>
						<p>本《数字证书使用协议》（以下简称“本协议”）适用于中石化电子签约平台以及使用的中石化电子签约平台产品或服务。</p>
						<h5>一、服务简介</h5>
						<p>1. 石化盈科信息技术有限公司与工信部许可的电子认证服务机构合作，由电子认证服务机构为通过实名认证后的企业颁发数字证书。</p>
						<p>2. 您通过石化盈科信息技术有限公司的中石化电子签约平台完成实名认证并使用数字证书获得电子签名服务，成为中石化电子签约平台电子签名体系不可分割的部分。</p>
						<p>3. 本协议中的“证书”指企业数字证书。</p>
						<h5>二、名词解释</h5>
						<p>1. 用户：指数字证书持有人以及申请使用数字证书的主体。</p>
						<p>2. 数字证书：电子认证服务机构签发的包含数字证书使用者身份信息和公开密钥的电子文件。</p>
						<p>3. CA机构：工业和信息化部批准的电子认证服务机构和国家密码管理局批准的电子政务电子认证服务机构，遵照《中华人民共和国电子签名法》为用户提供数字证书相关的电子认证服务。</p>
						<h5 style="font-weight:900;">三、使用声明</h5>
						<p style="font-weight:900;">1.
							您应在申请数字证书以前务必仔细阅读本协议，若您不同意本协议的任意内容，或者无法准确理解中石化电子签约平台对条款的解释，请不要点击同意并进行后续操作；若您点击同意，则表示您对本协议的全部内容已充分阅读并认可和同意遵守，同时，承诺遵守中国法律、法规、规章及其他政府规范性文件的规定，如有违反而造成任何法律后果，您将以本人名义独立承担所有相应的法律责任。
						</p>
						<p style="font-weight:900;">2. 您点击同意即表示您同意中石化电子签约平台将您的个人身份信息或企业信息传输至中CA机构用于申请数字证书。</p>
						<h5>四、证书申请</h5>
						<p>1.用户同意通过中石化电子签约平台合作的CA机构申请并使用该机构颁发给用户的数字证书，承诺在申请证书时提供真实、完整和准确的信息及证明材料。如因故意或过失未提供真实、完整和准确的信息，导致CA机构签发证书错误，造成相关各方损失的，由用户承担相关责任。
						</p>
						<p>2.用户在申请数字证书时应遵照CA机构的规程办理手续。</p>
						<p>3.中石化电子签约平台应积极响应用户发出的证书申请请求，及时将您提供的申请请求发送至CA机构用于签发数字证书。如果由于设备或网络故障而导致签发数字证书错误、延迟、中断或者无法签发，中石化电子签约平台和CA机构不承担任何赔偿责任。
						</p>
						<p style="font-weight:900;">4.
							用户在获得数字证书时应及时验证此证书所匹配的用户信息，如在收到后【两】个工作日内未提出异议则视为接受证书并承担该证书使用的责任和后果。</p>
						<p style="font-weight:900;">5.
							如果您的证书信息在证书有效期限内变更的，应当及时书面告知我们及CA机构，并终止使用该证书。如果发生企业名称变更、企业统一社会信用代码变更、经营期限届满等的，用户需要吊销原证书，重新申请数字证书。
						</p>
						<h5>五、证书使用</h5>
						<p>1. 数字证书用于网络上的用户身份标识、数字签名验证及密钥分配，但不包括涉及违反国家法律、法规或危害国家安全的用途。</p>
						<p>2. 用户应确保其应用系统能为数字证书提供安全的应用环境，若因网络、主机、操作系统或其他软硬件环境等存在安全漏洞，由此导致的安全事故及相关后果，中石化电子签约平台和CA机构不承担责任。
						</p>
						<p>3. 用户应当妥善保管数字证书以及调用数字证书的验证码或密码，不得泄漏或交付他人。如用户保管不善导致数字证书遭盗用、冒用、伪造或者篡改，用户应当自行承担相关责任。</p>
						<p style="font-weight:900">4.
							数字证书对应的私钥仅为用户本身访问和使用，用户对使用数字证书的行为负责。所有使用数字证书在中石化电子签约平台上签署电子文件或进行其他活动均视为用户所为，因此而产生的相关后果应当由用户自行承担。
						</p>
						<p style="font-weight:900">
							您应当对您所专有并控制的数字证书及您的中石化电子签约平台账户进行妥善保管，当您收到您在中石化电子签约平台账户点击“签约”时，应确保签署请求由本人发起。</p>
						<p>5. 数字证书一律不得转让、转借或转用。因转让、转借或转用而产生的相关后果应当由用户自行承担。</p>
						<p>6. 如遇数字证书遗失、被窃，或数字证书私钥泄露，用户应当立即到数字证书颁发的CA机构申请注销证书。</p>
						<h5>六、证书更新</h5>
						<p>1. 数字证书的有效期根据数字证书上的记录确定，有效期为1年，自签发之日起计算，您应当保证您在使用我们的中石化电子签约平台的服务时，您的数字证书处于有效期内。</p>
						<p>2. 因技术需要，如遇证书中的信息发生变更，用户应及时通过中石化电子签约平台向CA机构申请更新证书。若用户逾期没有更新证书，因此而产生的相关后果应当由用户自行负责。</p>
						<h5>七、证书吊销</h5>
						<p>1.
							如遇数字证书私钥泄露丢失、证书中的信息发生重大变更、或用户不希望继续使用数字证书的情况，用户应当立即向CA机构申请吊销证书。吊销手续遵循CA机构的规定。用户应当承担在证书吊销之前所有因使用数字证书而造成的责任。
						</p>
						<p>2.
							如果用户主体资格灭失（如企业注销等），法定代表人或授权代表通过中石化电子签约平台向CA机构请求吊销用户证书，用户主体及相关责任人应当承担其数字证书在吊销前所有使用数字证书而造成的相关后果。
						</p>
						<p>3. 对于下列情形之一，CA机构有权主动吊销所签发的证书：</p>
						<p>(1)用户申请证书时，提供不真实信息；</p>
						<p>(2)证书对应的私钥泄露或出现其他证书的安全性得不到保证的情况；</p>
						<p>(3)用户不能履行或违反了相关法律、法规和本协议所规定的责任和义务；</p>
						<p>(4)法律、法规规定的其他情形。</p>
						<h5>八、其他</h5>
						<p>1. 中石化电子签约平台与CA机构不对由于意外事件或其他不可抗力事件而导致暂停或终止全部或部分证书服务承担任何责任。</p>
						<p>2. 本协议的解释适用中华人民共和国法律。若发生任何纠纷或争议，首先应友好协商解决，协商不成的，任何一方均可向北京市朝阳区人民法院提起诉讼。</p>
						<p>3. 用户确认已经认真阅读并完全理解本协议中的各项规定，用户一旦在本页面点击同意即表明接受本协议的约束，本协议即时生效。</p>
						<!-- <p>数字证书使用协议历史版本参考：</p>
				      <p>中石化电子签约平台数字证书使用协议（发布日期：2020年01月10日）</p>
				      <p>中石化电子签约平台数字证书使用协议（发布日期：2019年08月05日）</p> -->
					</div>
					<div class="content" v-if="type === 2||type === '2'">
						<h4>中石化电子签约平台隐私政策声明</h4>
						<p>发布日期： 2021 年 11 月 26 日</p>
						<p>生效日期： 2021 年 11 月 26 日</p>
						<p>【石化盈科信息技术有限责任公司】（以下简称“我们”或“中石化电子签约平台”），常用办公地址：【北京市东城区东四十条甲22号南新仓商务大厦12层】，联系电话：【4009199000转3】
						</p>
						<p>中石化电子签约平台非常重视用户的隐私和个人信息保护。您在使用我们的产品或服务时，我们可能会收集和使用您的相关信息。我们希望通过《隐私政策声明
							》（“本政策”）向您说明我们在您使用我们的产品与/或服务时如何收集、使用、保存这些信息。<span
								style="display:inline">本政策与中石化电子签约平台所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，请您在使用我们的产品与/或服务前仔细阅读并确认您已经充分理解本政策所写明的内容。一旦您开始使用或在我们更新本政策后继续使用我们的产品与/或服务，即表示您已充分知悉、理解并同意本政策(含更新版本)内容，并且同意我们按照本政策处理您的相关信息。</span>
						</p>
						<p>本政策将帮助您了解以下内容：</p>
						<p>1、我们如何收集和使用您的个人信息</p>
						<p>2、我们如何共享、转让及披露您的个人信息</p>
						<p>3、我们如何保护和保存您的个人信息</p>
						<p>4、未成年人特别注意事项</p>
						<p>5、Cookie 和同类技术</p>
						<p>6、您的权利</p>
						<p>7、本政策如何更新</p>
						<p>8、联系我们</p>
						<p><span
								style="display:inline">相关词语涵义</span>个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本政策中涉及的个人信息包括：基本信息（如真实姓名、证件类型、证件号码、证件有效期限、电话号码和电子邮件地址）；身份信息；面部特征；网络标识信息（IP地址）；个人常用设备信息；个人位置信息等。
						</p>
						<p>企业信息：包括公司名称、公司证件类型、公司证件号码、公司证件有效期限、法定代表人真实姓名、定代表人身份证号码、法定代表人身份证有效期限、经办人真实姓名、经办人的证件类型、经办人的证件号码、经办人的电话号码、经办人的地址和经办人的电子邮件地址等。
						</p>
						<h5>一、我们如何收集和使用您的个人信息</h5>
						<p>我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：合法、正当、必要、诚信原则、目的明确和最小必要原则、公开透明原则、确定性原则、问责性与数据安全原则。同时，我们承诺，我们将按应有的安全标准，采取相应的安全保护措施来保护您的个人信息。
						</p>
						<p>我们会在下述场景中收集和使用您的个人信息。如果我们收集您的个人信息超出了下述声明的范围，或使用您的个人信息超出了与收集时所声称的目的具有直接或合理关联的范围，我们将在收集或使用您的个人信息前，再次向您告知并征得您的同意。
						</p>
						<p>1、账号注册</p>
						<p>当您在注册为中石化电子签约平台用户时，您需要填写注册信息，包括用户账户、<span
								style="font-weight:900;display: inline;">姓名</span>、<span
								style="font-weight:900;display: inline;">手机号码</span>、邮箱账号并创建登录密码，上述信息为您注册中石化电子签约平台账号所必需，若您不提供这类信息，您将无法继续使用我们的服务。当您成功注册账号后，您可以通过手机号码和短信验证码登录中石化电子签约平台，也可通过账号密码登录中石化电子签约平台的产品或服务。
						</p>
						<p>2、实名认证</p>
						<p>在您使用账号签发文件前，您需要进行自然人实名认证和企业认证。</p>
						<p>自然人实名认证需要提供您的<span style="font-weight:900;display: inline;">面部图像信息</span>和<span
								style="font-weight:900;display: inline;">手机号码</span>或<span
								style="font-weight:900;display: inline;">银行卡信息</span>。收集此类信息是为了验证您的真实身份，若您不提供这类信息，您将无法完成自然人实名认证，亦无法进行后续的企业认证并以企业身份签发文件。
						</p>
						<p>企业认证需要提供企业信息，包括：企业名称、社会信用代码及其有效期、法定代表人姓名及<span
								style="font-weight:900;display: inline;">身份证信息</span>。为了验证您是否具有相关授权代表企业进行认证，我们还将收集企业法定代表人的<span
								style="font-weight:900;display: inline;">面部图像信息</span>或要求您提供企业的盖章授权书，同时，您应当要求您的授权企业向中石化电子签约平台进行对公打款，以完成企业认证流程。收集此类信息是为了验证、核实企业的身份信息，您不提供这类信息，您将无法完成企业认证，亦无法进行以企业身份签发文件。
						</p>
						<p>3、签署验证信息</p>
						<p>在您实施电子签名时，我们会处理您的用户账户、<span
								style="font-weight:900;display: inline;">面部图像信息</span>，以核实是您本人在进行电子签名操作。若您不授权我们进行处理，您将无法实施电子签名。
						</p>
						<p>4、设备信息</p>
						<p>我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息（包括设备型号、操作系统版本、IP地址、设备MAC地址、IMEI、软件版本号等软硬件特征信息），我们会基于提供更便捷、更优的服务和体验收集您的以下的设备权限：
						</p>
						<p>（1）基于相机/摄像头权限：获取相机/摄像头权限是用于收集面部图像信息进行实名认证、身份认证的特定业务场景</p>
						<p>（2）基于照片的访问权限：在企业认证时用于上传企业认证授权书的场景；</p>
						<p>（3）基于存储权限：获取存储权限是为了保障客户端的稳定运行，记录运行日志。</p>
						<p>请您知悉获取上述权限的前提条件是您在您的设备中已允许开启相机/摄像头、照片访问权限、存储权限以实现这些权限所涉及信息的收集和使用。您可在您的设备的设置/应用权限（不同的设备类型有所不同）中查看上述权限的状态，并可根据需要选择开启或关闭相应的权限。请您注意，您开启任一权限即代表您授权我们可以收集或使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但不会影响此前基于您的授权所进行的信息收集及使用。
						</p>
						<p>5、日志信息</p>
						<p>我们会收集您对我们服务的详细使用情况，作为有关日志保存，包括接入网络的方式、类型和状态、网络质量数据、操作日志、服务日志信息。</p>
						<p>6、您通过我们的客服电话时所提交的个人信息：</p>
						<p>当您与我们联系时，我们可能会保存您的通信/通话记录和内容或您留下的联系方式等信息，以便与您取得联系或帮助您解决/定位问题，或记录相关问题的处理方案及结果。</p>
						<p>7、其他</p>
						<p>如果我们基于本政策未载明的其他特定目的收集您的个人信息时，会事先征求您的授权同意。</p>
						<p>8、例外情形：</p>
						<p>以下情形中，我们收集、使用个人信息不必征得您的授权同意：</p>
						<p>（1）为订立、履行个人作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；</p>
						<p>（2）为履行法定职责或者法定义务所必需；</p>
						<p>（3）为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</p>
						<p>（4）为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</p>
						<p>（5）依照法律规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；</p>
						<p>（6）法律、行政法规规定的其他情形。</p>
						<h5>二、我们如何共享、转让及披露您的个人信息</h5>
						<p>我们不会向任何第三方提供、出售、出租、分享和交易您的个人信息，但以下情况除外：1）事先获得您明确的单独同意或授权；2）我们可能会向合作伙伴等第三方共享您的个人信息。但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。
						</p>
						<p>我们的合作伙伴无权将共享的个人信息用于任何其他用途。我们的合作伙伴包括以下类型：</p>
						<p>1、第三方服务提供商</p>
						<p>我们可能会在特定领域与第三方服务提供商合作，为您提供服务。我们可能会将您的个人信息与这些第三方服务提供商共享，我们会与其签署严格的保密协议或条款，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理个人信息，并采取适当的保密和安全措施保障个人信息安全。
						</p>
						<p>（一）共享：</p>
						<p style="font-weight:900;">我们会将您的姓名、手机号、银行卡号、面部图像信息、法定代表人的姓名及身份证信息共享给电子认证服务提供者（CA, Certificate
							Authority），即北京国富安电子商务安全认证有限公司，用于进行实名认证、企业认证以及身份核验。（北京国富安电子商务安全认证有限公司的【<a
								@click="openPrivacyment(5)">隐私政策</a>】） </p>
						<p>（二）委托处理：</p>
						<p style="font-weight:900;">
							我们会将您的实名认证过程、企业的认证过程，以及签约过程中的面部图像信息识别过程、CA证书签约过程在中石化电子签约平台上的相关日志信息提供给【北京信任度科技有限公司】，委托其将上述信息用于在长城链上链以实现对日志信息进行实时备份。<span
								style="display:inline">请您知悉长城链与北京互联网法院的天平链对接。</span></p>
						<p>通过SDK方式共享：某些产品或服务可能由我们服务提供方提供，我们会通过SDK的形式向您提供产品或服务，在此过程中，我们的服务提供方可能会收集、使用和存储您的相关数据或信息，其中包括：接入人脸核身SDK会收集您的摄像头权限、网络权限、手机状态、设备IMEI号，通过拍摄人脸并采集视频照片，用于活体检测和人脸比对，以核实是否为真实本人。
						</p>
						<p>我们会按照内部标准，必要时开展个人信息安全影响评估，根据评估结果严格筛选和业务所必须的合作伙伴，并对获取您个人信息的第三方开展安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照我们的委托目的、服务说明、本权政策以及其他任何相关的保密和安全措施来处理您的个人信息。如需获悉关于我们接入使用的第三方收集、使用您个人信息的类型和目的以及其他任何相关的保密和安全措施，可前往其官网参阅其详细隐私政策。<span
								style="display:inline">请您知悉我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。同时我们制定第三方供应商管理内控流程，定期对合作伙伴的服务、安全能力、舆情进行评估和监控，一旦发现我们的合作伙伴有违法违规行为，我们会予以核实后及时中止与这些第三方的合作，及时保障您的权益。如您在使用过程中对我们使用的第三方服务和供应商有任何疑问您可通过本政策中提供的联系方式与我们取得联系。我们会及时解答您的疑惑。</span>
						</p>
						<p>如果我们因合并、分立、解散、被宣告破产的原因需要转移个人信息的，我们会向您告知接收方的名称或者姓名和联系方式。接收方将继续履行本政策及其他法定义务。接收方变更原先的处理目的、处理方式的，会重新取得您的同意。
						</p>
						<p>2、公开披露</p>
						<p>我们不会对外公开披露我们收集的个人信息，如必须公开披露时，我们会向您告知此次公开披露的目的、披露信息的类型及可能涉及的敏感个人信息，并征得您的单独同意。</p>
						<p>3、出于法律原因的共享</p>
						<p>在不违反本政策要求的前提下，我们可能需要在特定情形共享或披露您的个人信息。在以下情形中，共享、转让、公开披露个人信息无需征得您的授权和同意：</p>
						<p>（1）为订立、履行个人作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；</p>
						<p>（2）为履行法定职责或者法定义务所必需；</p>
						<p>（3）为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</p>
						<p>（4）为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</p>
						<p>（5）依照法律规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；</p>
						<p>（6）法律、行政法规规定的其他情形。</p>
						<h5>三、我们如何保存和保护您的信息</h5>
						<p>我们所收集的用户信息和资料将加密保存在中华人民共和国境内。在您使用我们的产品与/或服务期间，您的个人信息将在为了实现本政策所述目的之期限内保存，同时将结合法律有强制的留存要求期限的规定确定。在超出保存期间后，我们会根据适用法律的要求删除您的个人信息，或进行匿名化处理。
						</p>
						<p>我们将采取一切合理可行数据安全技术措施，保护您的个人信息，包括：</p>
						<p>（1）我们将您的个人信息存储在位于受控场所的计算机系统中，并采取了通用的安全措施。</p>
						<p>（2）我们仅允许为产品及服务运营目的而必需处理相关个人信息的特定员工访问个人信息，且要求他们履行严格的保密义务。 </p>
						<p>（3）我们不断努力保障您的个人信息安全，并在个人信息的传输过程中采取全程加密的手段，防止您的信息遭受未经授权的访 问、使用、修改、毁损或泄露。 </p>
						<p>（4）我们在传输和存储您的特殊类型的个人信息时，将更为慎重，采取加密等技术安全措施保障个人信息安全。</p>
						<p>（5）我们严格保护您的个人信息安全。我们使用各种制度、安全技术和程序等措施来保护您的个人信息不被未经授权地访问、篡改、披露或破坏。我们将根据国家法律法规的要求保障信息的安全。如发生个人信息安全事件，我们将按照法律法规的要求以推送通知或公告等形式及时通知您，向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处理措施、您可自主防范和降低的风险的建议、对您的补救措施等。我们会及时处置系统漏洞、网络攻击、病毒侵袭及网络侵入等安全风险。
						</p>
						<p>如果您对我们的个人信息保护有任何疑问，可通过本平台的联系方式联系我们。如您发现自己的个人信息泄密，尤其是您的帐号密码及个人信息发生泄露，请您立即联络我们，以便我们采取相应措施。</p>
						<h5>四、未成年人特别注意事项</h5>
						<p>如果您未满18周岁，您无权使用我们的服务，我们也不会向您提供任何服务。</p>
						<h5>五、Cookie的使用</h5>
						<p>为使您获得更轻松的访问体验，您使用我们的产品或服务时，我们可能会通过采用各种技术收集和存储您访问中石化电子签约平台服务的相关数据，在您访问或再次访问中石化电子签约平台服务时，我们能识别您的身份，并通过分析数据为您提供更好更多的服务。包括使用小型数据文件识别您的身份，这么做是为了解您的使用习惯，帮您省去重复输入账户信息的步骤，或者帮助判断您的登录状态以及账户安全。这些数据文件可能是Cookie，或您的浏览器或关联应用程序提供的其他本地存储（统称“Cookie”）。
						</p>
						<p>我们不会将 Cookies 用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookies。您可以清除计算机上保存的所有
							Cookies，大部分网络浏览器会自动接受Cookies，但您通常可根据自己的需要来修改浏览器的设置以拒绝
							Cookies；另外，您也可以清除软件内保存的所有Cookies。但如果您这么做，您可能需要在每一次访问我们的网站时亲自更改用户设置，而且您之前所记录的相应信息也均会被删除。</p>
						<h5>六、您的权利</h5>
						<p>我们非常重视您对个人信息的关注，并尽全力保护您对于您个人信息访问、更正、删除的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：</p>
						<p>1、访问、更正和补充</p>
						<p>我们鼓励您更新、修改和补充您的信息以使其更准确有效。除法律规定外，您有权访问您的信息，并进行修改、补充。您可以申请更正您的信息。在访问、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障您的账户安全。
						</p>
						<p>2、删除</p>
						<p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>
						<p>（1）您的个人信息对于实现收集或处理的目的已不再必要；</p>
						<p>（2）您已经撤回我们对您个人信息处理的同意； </p>
						<p>（3）我们停止提供产品或服务，或者保存期限已届满；</p>
						<p>（4）我们违反法律、行政法规或违反约定处理个人信息；</p>
						<p>（5）法律、行政法规规定的其他情形。</p>
						<p>3、拒绝、返还、转移、索取数据副本</p>
						<p>您可以向我们提出拒绝、返还、转移、索取个人信息副本的请求。</p>
						<p>4、改变您授权同意的范围</p>
						<p>每个业务功能需要一些基本的个人信息才能得以完成。对于额外收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意。</p>
						<p>您可以撤回您的授权同意。</p>
						<p>当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>
						<p>5、提出异议</p>
						<p>若您认为我们对您个人信息的处理违反了本政策或相关法律法规的要求，您可以提出您的异议。</p>
						<p>6、注销</p>
						<p>在您需要终止使用我们的服务时，您可以申请注销您的账户，您可以申请注销您的账户。</p>
						<p>我们在此善意地提醒您，您注销账户的行为会使您无法继续使用中石化电子签约平台的相关服务，包括合同下载。注销账户后您的个人信息会保持不可被检索、访问的状态，我们将不会再使用或对外提供与该账户相关的个人信息，但您在使用中石化电子签约平台服务期间提供或产生的信息我们会保存5年，且在保存的时间内依法配合有权机关的查询。
						</p>
						<p style="font-weight:900">请您知悉，鉴于区块链技术的不可修改、不可删除的特性，我们无法响应您有关修改、删除上链至长城链中相关信息的请求。</p>
						<p>您希望行使上述权利时，可以通过客服电话与我们联系。在收到您的请求后，我们可能会首先验证您的身份，并可能会要求您提供必要的信息以进行身份验证。我们会在收到您的请求之后尽快与您取得联系。如我们有理由认为无需对您的请求采取任何措施，我们也会向您告知我们的决定，并向您做出相应的解释。我们将尽最大努力帮助您解决相关问题。如您对我们的答复不满意，您可以向相关监管机关投诉，或向有管辖权的司法机关提起诉讼。
						</p>
						<h5>七、本政策如何更新</h5>
						<p>我们可能适时变更、修订本《隐私政策》的条款。变更、修订的内容将构成本《隐私政策》的一部分。如该等修订造成您在本《隐私政策》下权利的实质减少，我们将在修订生效前通过在主页上显著位置提示或向您发送电子邮件或以其他方式通知您。届时，请您务必完整阅读和充分了解更新或修改后的隐私政策。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。
						</p>
						<p>本隐私政策所指的重大变更包括：</p>
						<p>1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>
						<p>2、个人信息共享、转让或公开披露的主要对象发生变化；</p>
						<p>3、您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
						<p>4、其他可能对您的个人信息权益产生重大影响的变化。</p>
						<h5>八、联系我们</h5>
						<p>如您对本政策存在任何问题或建议，或者发现任何违反本政策的行为，请随时联系我们，我们为您提供了多种反馈通道，希望为您提供满意的解决方案：</p>
						<p>客服通道：您可以拨打我们的客服电话【4009199000转3】与我们联系；</p>
						<p>办公地址：【北京市东城区东四十条甲22号南新仓商务大厦12层】。</p>
						<!-- <span>九、法律声明</span>
				      <p>若要访问和使用平台服务，您必须完全接受本协议中所包含的条款、条件，并且遵守有关互联网及/或本平台的相关法律、规定。一旦您使用中石化电子签约平台服务，即表示您同意并接受了所有该等条款、条件。</p>
				      <p>隐私政策历史版本参考：</p>
				      <p>中石化电子签约平台隐私政策（发布日期：2020年01月10日）</p>
				      <p>中石化电子签约平台隐私政策（发布日期：2019年08月05日）</p> -->
					</div>
					<div class="content" v-if="type === 3||type === '3'">
						<h4>实名认证服务协议</h4>
						<p>
							实名认证服务协议（以下简称“本协议”）是石化盈科信息技术有限责任公司（以下简称“我们”或“电子签约平台”）提供的电子签约平台与用户（以下尊称“您”）就实名认证服务（以下简称“本服务”）的使用等相关事项所订立的有效合约。
						</p>
						<p><span
								style="display:inline">本协议有助于您理解我们为您提供的服务内容及您的权利和义务，请您仔细阅读。</span>如您对本协议内容有疑问，请勿进行下一步操作。您可通过客服电话【4009199000转3】进行咨询，以便我们为您解释和说明。<span
								style="display:inline">如您通过网络页面点击或以其他形式确认本协议的，即视为您已充分理解本协议所有条款，同意与电子签约平台订立本协议并接受本协议的约束。</span>
						</p>
						<h5>一、定义</h5>
						<p>
							实名认证服务：本服务由【北京国富安电子商务安全认证有限公司】提供技术支持，通过证件信息核验、人脸比对、校验码回填、人工审核、可信环境验证等方式确认您及您所属企业身份的真实性，并将认证结果反馈给电子签约平台的服务。
						</p>
						<h5>二、授权与许可</h5>
						<p>2.1
							为向您提供本服务，我们需要将您在申请服务过程中所填写或留存的信息，包括姓名、身份证号码、手机号码、银行卡号、人脸照片提供给北京国富安电子商务安全认证有限公司。信息收集范围请您查阅认证服务页面的具体提示。
						</p>
						<p>2.2
							为准确核验您的身份，尽量防止您的身份被冒用，您授权电子签约平台、北京国富安电子商务安全认证有限公司采集您的设备信息以验证您在进行认证时是否处于可信环境，并根据不同的认证方式按需收集您的人脸照片、身份证件、银行卡号、手机号、组织机构统一社会信用代码、企业对公账户等信息。
						</p>
						<p>2.3
							为准确验证您的身份，电子签约平台需在必要时将前款载明的信息提供给北京国富安电子商务安全认证有限公司，并由将北京国富安电子商务安全认证有限公司把前款载明的信息提交至合法存有您信息的第三方机构进行比对核验，以便核验您的身份真实性。
						</p>
						<p>
							2.4在使用到身份证号或银行卡时，会另外征得您的同意和授权；在使用到人脸信息时，会另外征得您的同意和授权。授权均仅当次有效，下次使用到对应功能时，会再次征得您的同意和授权。</p>
						<h5>三、您的权利义务</h5>
						<p>3.1
							电子签约平台会尽力提升核验结果的准确性，但由于电子签约平台能收集到的信息范围有限，以及行业技术水平及核验手段仍在完善过程中，电子签约平台无法确保核验结果完全准确无误。如您发现核验结果不准确，您可通过客服电话告知我们，以便我们重新核验并逐步提升核验能力。
						</p>
						<p>3.2
							您不得将本服务用于中国法律法规所限制或禁止，以及违背道德风俗的领域，否则因此导致电子签约平台或第三方遭受损失的，您应承担相应赔偿责任。</p>
						<p>3.3
							如您发现我们收集、使用您个人信息的行为，违反了法律、行政法规规定或违反了与您的约定，或您发现我们采集、储存的您的个人信息有错误的，您可通过客服电话告知我们，要求删除或更正。</p>
						<p>3.4 您应当知悉，本服务仅对个人或企业身份的真实性进行校验。</p>
						<h5>四、电子签约平台的权利义务</h5>
						<p>4.1 电子签约平台应按本协议约定向您提供本服务。</p>
						<p>4.2 电子签约平台会根据认证技术的发展及市场风险环境的需要，不断调整完善相应认证服务的内容及形式。</p>
						<h5>五、除外责任</h5>
						<p>您理解并同意，鉴于计算机、互联网的特殊性，下述情况不属于电子签约平台违约：</p>
						<p>
							1）因自然灾害如洪水、地震、瘟疫流行等以及社会事件如战争、动乱、政府行为、电信主干线路中断、网路堵塞、电信部门技术调整和政府管制等导致本服务不能提供或中断；</p>
						<p>2）黑客攻击造成服务中断、信息数据泄露；但我们应按照本协议约定做好应急处理；</p>
						<p>3）电子签约平台在进行服务器配置、维护时，需要短时间中断服务；</p>
						<p>4）由于Internet上的通路阻塞造成您网站访问速度下降；</p>
						<p>5）因国家法律法规及政策的相关要求，中断或终止本服务。</p>
						<h5>六、协议变更</h5>
						<p>为了满足您多样化和专业化的服务需求，我们将根据国家法律、法规及其他规范性文件及业务需要，可能增加、变更服务内容或服务方式，<span
								style="display:inline">我们可能对本协议内容进行变更，并以在电子签约平台官方网站发布公告的方式提前予以公布。若您不接受本协议的变更，您有权自主决定选择停止使用本服务。若您在公告约定的生效时间后继续使用本服务的，表示您已充分阅读、理解并接受变更修改后的协议内容。</span>
						</p>
						<h5>七、适用法律及管辖条款</h5>
						<p>
							本协议适用中华人民共和国法律（仅为本协议之目的，不包括香港特别行政区、澳门特别行政区及台湾地区法律）。因电子签约平台与您就本协议的签订、履行或解释发生争议，双方应努力友好协商解决。如协商不成的，电子签约平台和您均可向北京市朝阳区人民法院提起诉讼。
						</p>
					</div>
					<div class="content" v-if="type === 5||type === '5'">
						<h4>隐私政策声明</h4>
						<p>
							本服务是由北京国富安电子商务安全认证有限公司（以下简称“本公司”）向用户提供的一种移动化电子签名服务。服务包括但不限于通过移动app及用户持有的数字证书对用户各类数据电文或电子缔约文件等进行电子签名，用户实名认证，企业实名认证手写签名等。
						</p>
						<p>我们非常重视用户的隐私和个人信息保护。您在使用我们的产品或服务时，我们可能会收集和使用您的相关信息。我们希望通过《隐私政策声明
							》（“本政策”）向您说明我们在您使用我们的产品与/或服务时如何收集、使用、保存这些信息。请您在使用我们的产品与/或服务前仔细阅读并确认您已经充分理解本政策所写明的内容。
						</p>
						<span>一、信息收集范围</span>
						<p>当您在注册为系统用户时，我们要求您填写注册信息。</p>
						<p>
							个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本政策中涉及：</p>
						<p>1.个人信息包括：基本信息（如真实姓名、证件类型、证件号码、电话号码和电子邮件地址）；身份信息；面部特征。</p>
						<p>
							2.企业信息包括公司名称、公司证件类型、公司证件号、法定代表人代表真实姓名、法定代表人代表身份证号、经办人真实姓名、经办人的证件类型、经办人的证件号码、经办人的电话号码、经办人的地址和经办人的电子邮件地址等。
						</p>
						<p>
							我们通过（a）实名认证验证您的真实身份，作为是否为您提供服务的依据；（b）比较您的申请信息和您提交的相关证件复印件/原件一致性并作为是否为您提供服务的依据；（c）在获得您本人同意的情况下，委托有合法资质的第三方机构对您的身份信息进行核实，作为是否为您提供服务的依据。
						</p>
						<p>3.此外，为了保障我们服务的可用性、连续性及您的账户安全，我们会收集您的下述信息：</p>
						<p>
							设备信息：设备型号、操作系统版本、唯一设备标识符、IP及位置信息。例如，我们可能会通过IP地址、GPS、WiFi或基站等途径获取您的地理位置信息。您可以选择开启或关闭地理位置信息的授权，如您关闭授权的，与地理位置相关的功能可能无法使用。
						</p>
						<p>软件信息：软件的版本号、浏览器类型。为确保操作环境的安全或提供服务所需。</p>
						<p>
							某些设备权限：我们可能基于您的允许获得某些设备权限，包括相机/摄像头权限，用于人脸识别等特定的服务场景；访问照片权限，用于特定服务场景下您自行选择需要上传的保存在您相册内的图片。请您知悉您可以通过您的设备的应用权限选择开启/关闭上述权限的状态。我们仅能在您允许前提下获得上述权限。
						</p>
						<p>
							服务日志信息。您在使用我们服务时接入网络的方式、类型和状态、登录时间、操作日志、服务日志等我们提供服务相关的日志信息。</p>
						<span>二、收集的信息可能用作下列用途</span>
						<p>
							（1）提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性。</p>
						<p>（2）帮助我们设计新服务，改善我们现有服务。</p>
						<p>（3）使我们更加了解您如何接入和使用我们的服务。</p>
						<p>（4）让您参与有关我们产品和服务的调查。</p>
						<p>
							我们APP通过SDK方式共享的信息：某些产品和服务可能由我们的授权合作机构提供，我们会通过SDK的形式向您提供产品或服务。在此过程中，我们的授权合作机构可能会收集、使用和存储您的相关数据或信息，我们列举了具体的授权合作机构，并提供了该第三方的隐私政策链接，我们建议您阅读该第三方的隐私政策。
						</p>
						<p>微信分享SDK：由深圳市腾讯计算机系统有限公司提供微信分享服务。微信分享SDK需要采集设备标识符(IMEI/Mac/android
							ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI
							信息)，用于唯一标识设备，以便向目标设备分享消息。详细内容请访问《腾讯隐私政策》。收集目的及必要性：APP需要集成微信分享SDK，让用户能够通过微信分享功能，把签署业务、审批业务或者签署的文档分享给微信里对应的账号。
						</p>
						<span>三、信息的披露和使用</span>
						<p>
							我们不会向任何无关第三方提供、出售、出租、分享和交易用户信息，但为方便您使用平台服务，您同意并授权我们将您的用户信息传递给您同时接受其他服务的关联公司或其他组织，或从为您提供其他服务的关联公司或其他组织获取您的用户信息，法律禁止的除外。我们可批露或使用您及（或）您的公司的用户信息以用于识别和（或）确认您的身份，或解决争议，或有助于确保网站安全、限制欺诈、非法或其他刑事犯罪活动，以执行我们的服务协议。我们可批露或使用您及（或）您的公司的用户信息以保护您的生命、财产之安全或为防止严重侵害他人之合法权益或为公共利益之需要。我们可批露或使用您及（或）您的公司的用户信息以改进我们的服务，并使我们的服务更能符合您的要求，从而使您在使用我们服务时得到更好的用户体验。我们利用您及（或）您的公司的用户信息与您联络，并向您提供您感兴趣的信息。当我们被法律强制或依照政府或依权利人因识别涉嫌侵权行为人的要求而提供您的信息时，我们将善意地披露您的资料。
						</p>
						<span>四、保存和保护您的信息</span>
						<p>
							（1）所收集的用户信息和资料将加密保存在服务器上，并采取一切合理可行数据安全技术措施，保护您的个人信息。我们将尽力确保或担保您发送给我们的任何信息的安全性。尽管我们有这些安全措施，但请注意，在因特网上不存在“绝对安全的安全措施”。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
						</p>
						<p>
							（2）如果您对我们的个人信息保护有任何疑问，可通过本平台的联系方式联系我们。如您发现自己的个人信息泄密，尤其是您的帐号密码及个人信息发生泄露，请您立即联络我们，以便我们采取相应措施。
						</p>
						<span>五、未成年人特别注意事项</span>
						<p>如果您未满18周岁，您无权使用本公司服务，因此我们希望您不要向我们提供任何个人信息。</p>
						<span>六、Cookie的使用</span>
						<p>
							cookies是少量的数据，在您未拒绝接受cookies的情况下，cookies将被发送到您的浏览器，并储存在您的计算机硬盘中。我们使用cookies储存您访问我们平台的相关数据，在您访问或再次访问我们的平台时，我们能识别您的身份，并通过分析数据为您提供更好更多的服务。
						</p>
						<span>七、变更</span>
						<p>
							我们可能适时修订本《隐私政策》的条款，修订构成本《隐私政策》的一部分。如该等修订造成您在本《隐私政策》下权利的实质减少，我们将在修订生效前通过在主页上显著位置提示或向您发送电子邮件或以其他方式通知您。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的本《隐私政策》的约束。
						</p>
						<span>八、保密条款</span>
						<p>
							任何人均需严格遵守保密条款，保护各方商业秘密及相关权益，包括但不限于产品知识产权、策划方案、客户资料、协议合同、技术文档、程序文件、程序控件或源代码、各种账户密码。任何人不得泄漏他人的任何商业秘密，同时不得利用工作之便获取他人技术秘密。对于授权使用的技术，只能使用于授权时指定的范围，不得用于它途。
						</p>
						<span>九、法律声明</span>
						<p>
							若要访问和使用本服务，您必须完全接受本协议中所包含的条款、条件，并且遵守有关互联网及/或本平台的相关法律、规定。一旦您使用我们的服务，即表示您同意并接受了所有该等条款、条件。</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from "vue";
	export default {
		data() {
			return {
				//头部标题
				headertitle: '用户服务协议',
				//内容
				type: 1, // 1 用户服务协议  2 隐私政策声明协议  3 实人认证服务协议 4 数字证书使用协议 5 国富安隐私协议
			};
		},
		mounted() {
			this.type = this.$route.params.type||this.$route.query.type
			console.log(this.type)
			switch (this.type) {
				case 1:
				case '1':
					this.headertitle = '用户服务协议'
					break;
				case 2:
				case '2':
					this.headertitle = '隐私政策声明'
					break;
				case 3:
				case '3':
					this.headertitle = '实名认证服务协议'
					break;
				case 4:
				case '4':
					this.headertitle = '数字证书使用协议'
					break;
				case 5:
				case '5':
					this.headertitle = '隐私政策声明'
					break;
			}
		},
		methods: {
			//
			openPrivacyment(type) {
				this.type = type
				this.headertitle = '隐私政策声明'
				document.getElementById('app_main').scrollTop = 0
			},
		}
	};
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";

	.agreement {
		color: #666;
		position: relative;
		max-height: 100%;
		overflow-y: scroll;
		// overflow: auto;

		.content {
			min-height: 100%;

			p {
				font-size: .7rem;
				line-height: 1rem;

				a {
					color: #0277FC;
				}
			}

			div {
				font-size: .7rem;
				line-height: 1rem;
			}

			h4 {
				line-height: 1.2rem;
				font-size: .8rem;
			}

			h5 {
				line-height: 1.4rem;
				font-size: .8rem;
				color: #333;
				font-weight: bold;
			}

			span {
				display: block;
				font-size: .7rem;
				font-weight: bold;
			}

		}


	}
</style>